export const POPUP_OAUTH2_COMPLETE = 'popupOAuth2Complete';
